(function() {
    'use strict';

    angular.module('app.calendarizaciones', []);
})();
